import * as React from 'react'

import { cn } from '@/lib/utils'

const Container = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-panel border border-canvas-border bg-card text-card-foreground shadow-panel', // panels sit on the canvas: darker blue edge
      className
    )}
    {...props}
  />
))
Container.displayName = 'Container'

const ContainerHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col space-y-1.5 p-6', className)}
    {...props}
  />
))
ContainerHeader.displayName = 'ContainerHeader'

const ContainerTitle = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'text-2xl font-semibold leading-none tracking-tight',
      className
    )}
    {...props}
  />
))
ContainerTitle.displayName = 'ContainerTitle'

const ContainerContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
))
ContainerContent.displayName = 'ContainerContent'

export { Container, ContainerHeader, ContainerTitle, ContainerContent }
